import {Nullable} from "@data-force/app";
import {Selector} from "./selectorType";
import StoreState from "../../interfaces/store/storeState";
import {Task} from "../../interfaces/store/actions/payload/task";
import {Cursor} from "../../interfaces/store/cursor";

const selectTasks: Selector<Task[]> = (({task: {list}}: StoreState): Task[] => list);

const selectTasksCursor: Selector<Nullable<Cursor>> = (({task: {cursor}}: StoreState): Nullable<Cursor> => cursor);

export {
    selectTasks,
    selectTasksCursor,
};
